import { useEffect, useState } from 'react';
import { apiService } from '../../services/api';
import { TrackerPermissions } from '../../types';

/** Mirrors catalyst_tracker/roles.py exactly: owner = is_superuser, editor = is_admin || is_superuser.
 * There's no dedicated catalyst-tracker "who am I" endpoint; the app-wide GET /api/user already carries
 * is_admin/is_superuser, so we compute the two booleans the old server-rendered page injected as
 * `ruby_user.editor` / `ruby_user.owner` from that. */
export function useTrackerPermissions() {
  const [permissions, setPermissions] = useState<TrackerPermissions | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiService.getCurrentUser()
      .then((user: any) => {
        if (cancelled || !user) return;
        setPermissions({
          userId: String(user.id ?? ''),
          email: String(user.email ?? ''),
          editor: Boolean(user.is_admin || user.is_superuser),
          owner: Boolean(user.is_superuser),
        });
      })
      .catch(() => {
        if (!cancelled) setPermissions({ userId: '', email: '', editor: false, owner: false });
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { permissions, loading };
}

export default useTrackerPermissions;
